module.exports = __webpack_public_path__ + "img/thumbnail_BZ_Liberec_logo.c10ded2f.png";